import type { QueryClient } from '@tanstack/react-query';

import type { OutgoingEntry } from '../hooks/useOutgoingMessages';

/**
 * Ящики исходящих (см. `hooks/useOutgoingMessages`) - отдельным модулем, чтобы выход из аккаунта
 * мог их очистить, не подтягивая за собой хуки переписки.
 *
 * Ящики живут при клиенте запросов, а не при компоненте.
 *
 * Компонент ленты перемонтируется на ровном месте - именно с этого и начинается гонка, - и
 * ящик в `ref` уехал бы вместе с ним прямо посреди летящей отправки. Клиент запросов при этом
 * тот же самый, что и у ленты, живёт столько же, сколько её кеш, и на сервере он свой на каждый
 * запрос: общего состояния между посетителями тут не появляется. `WeakMap` снимает и вопрос
 * уборки - ящики уходят вместе с клиентом.
 */
const boxes = new WeakMap<QueryClient, Map<string, OutgoingEntry[]>>();

export const boxOf = (queryClient: QueryClient): Map<string, OutgoingEntry[]> => {
  const existing = boxes.get(queryClient);
  if (existing) {
    return existing;
  }

  const created = new Map<string, OutgoingEntry[]>();
  boxes.set(queryClient, created);

  return created;
};

/**
 * Выход из аккаунта: все ящики клиента забываются. Иначе недоотправленные строки прошлого
 * аккаунта доклеились бы в ленту следующего, открой он переписку с тем же номером.
 */
export const clearOutgoingMessages = (queryClient: QueryClient): void => {
  boxes.delete(queryClient);
};
